module.exports = __webpack_public_path__ + "static/media/ship-icon.2b918e20.svg";